import GeneralPageTemplate from '@/components/template/generalPageTemplate';
import ElectronicBulletin from '../components/organisms/electronic-bulletin/electronicBulletin';
import { graphql, useStaticQuery } from 'gatsby';
import '../styles/index.scss';

const Tienda = () => {
    const data = useStaticQuery(graphql`
        query GET_PORTAL_SERVICIOS_BOLETINES_COMFAMA {
            allContentfulTemplate(
                filter: { titulo: { eq: "Contenedor de Boletines Comfama" } }
            ) {
                nodes {
                    metaInfo {
                        metaTitulo
                        metaDescripcion
                        metaImagen {
                            file {
                                url
                            }
                        }
                        urlCanonical
                        noIndex
                    }
                    referencias {
                        ... on ContentfulTemplate {
                            titulo
                            subtitulo
                            imagen {
                                title
                                file {
                                    url
                                }
                                gatsbyImage(width: 700, formats: [AUTO, WEBP], placeholder: BLURRED)
                                svg {
                                    publicURL
                                }
                            }
                            boton {
                                copy
                                redireccion
                            }
                        }
                    }
                    secciones {
                        titulo
                        subtitulo
                        referencias {
                            ... on ContentfulInfoCard {
                                titulo
                                descripcion {
                                    raw
                                }
                                redireccion
                                icono {
                                    title
                                    file {
                                        url
                                    }
                                    gatsbyImage(width: 700, formats: [AUTO, WEBP], placeholder: BLURRED)
                                    svg {
                                        publicURL
                                    }
                                }
                            }
                        }
                    }
                    estoTambien {
                        titulo
                        subtitulo
                        referencias {
                            ... on ContentfulTemplate {
                                titulo
                                subtitulo
                            }
                        }
                        secciones {
                            titulo
                            subtitulo
                        }
                        boton {
                            copy
                            redireccion
                        }
                    }
                    modal {
                        nombre
                        subtitulo
                        referencias {
                            ... on ContentfulBoton {
                                copy
                                redireccion
                            }
                        }
                        descripcion {
                            raw
                        }
                        boton {
                            copy
                            redireccion
                        }
                    }
                    estaActivo
                }
            }
        }
    `);
    const metaData = data?.allContentfulTemplate?.nodes[0]?.metaInfo[0];
    const content = data?.allContentfulTemplate?.nodes[0];
    return (
        <GeneralPageTemplate data={metaData} isActive={content?.estaActivo}>
            <ElectronicBulletin contentfulData={content} />
        </GeneralPageTemplate>
    );
};

export default Tienda;
